import WelcomeScreen from "./WelcomeScreen";

export const WELCOME_SCREEN = "welcome";

export default {
    [WELCOME_SCREEN] : WelcomeScreen,
}
